import { ApiFeatureState } from "./rootReducerTypes";
import { UpdateApiFeaturesAction, UPDATE_API_FEATURES, ApiFeaturesActionTypes } from "./apiFeaturesActionAndReducerTypes";

//#region actions
export function updateApiFeatures(backendName: string, apiFeatures: string[]): UpdateApiFeaturesAction {
  return {
      type: UPDATE_API_FEATURES,
      backendName: backendName,
      apiFeatures: apiFeatures,
  };
}

export default function apiFeaturesReducer(state: ApiFeatureState = initialState, action: ApiFeaturesActionTypes): ApiFeatureState {
  switch (action.type) {
      case UPDATE_API_FEATURES:
          return {
              ...state,
              backendName: action.backendName,
              apiFeatures: action.apiFeatures
          };
      default:
          return state;
  }
}

export const initialState: ApiFeatureState = {
  backendName: undefined,
  apiFeatures: undefined
};
